// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';
import { z } from 'zod';

type CreateTicketResponse = z.infer<typeof successResponseSchema>;

interface CreateTicketParameters {
  note: string;
}

/**
 * Updates an existing project in the remote API.
 *
 * @param parameters.customerId - The ID of the customer associated with the
 * project.
 * @param parameters.locationIds - The IDs of the locations associated with the
 * project.
 */
export async function createTicketNote(
  key: string,
  parameters: CreateTicketParameters
): Promise<CreateTicketResponse> {
  const url = `/v1/ticket/${key}/note`;
  const response = await api.post(url, {
    ...parameters,
  });

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'CreateTicketNote',
    endpoint: url,
  });
}
